import * as React from 'react';
import { Image, ImageBackground, StyleSheet, Text, TouchableOpacity, View, Linking, Dimensions } from 'react-native';
import { Colors, Fonts } from '../utils/Constants';

export default class ChecklistAction extends React.PureComponent{
  constructor(props){
    super(props);
    this.state= {
        hovering: false,
    }
  }

  hoverButton = () => {
    if(this.props.selectedFilter !== this.props.index && !("ontouchstart" in document.documentElement)){
      this.setState({
        hovering: !this.state.hovering
      })
    }
  }

  onPress = () => {
    this.props.action(this.props.index);
    this.setState({hovering: false});
  }

  render(){
    var properties = {
      underline: 0,
      textColor: 'black'
    };

    if(this.props.selectedFilter === this.props.index){
      properties = {
        underline: 1,
        textColor: 'black',
        fontWeight: '600',
      }
    }else{
      if (this.state.hovering) {
        properties = {
            underline: 1,
            textColor: 'black',
            fontWeight: '600',
        }
      }
      else {
          properties = {
          underline: 0,
          textColor: 'black',
          fontWeight: '400',
          }
      }
    }

    return (
    <TouchableOpacity style={{flexShrink: 1, height: this.props.height, marginBottom: 10}} onPress={this.onPress} onMouseEnter={() => this.hoverButton()} onMouseLeave={() => this.hoverButton()}>
      <View style = {[styles.button, {height: '100%'}]}>
        <Text style={[styles.description, {color: properties.textColor, fontWeight: properties.fontWeight, borderBottomWidth: properties.underline}]}>{this.props.text}</Text>
      </View>
    </TouchableOpacity>
    );
  }
}

ChecklistAction.navigationOptions = {
  header: null,
};

const styles = StyleSheet.create({
  button: {
    padding: 15,
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row',
    flexShrink: 1,
    flexDirection: 'row',
    marginBottom: 10,
    marginRight:5,
  },
  description: {
    fontFamily: Fonts.mainFont,
    fontSize: 16.13,
    fontWeight: '400',
  }
});